import JshModule from '@core/scripts/helper/jsh-module';

const {moduleScope} = JshModule('teaser/glossary-large-navi');

if (moduleScope.querySelectorAll('li.onsite-navigation__item.-level__1').length > 0) {
	showMoreOnClick('-level__1');
} else {
	showMoreOnClick('-level__0');
}

function showMoreOnClick(parentElementClass) {
	const listStructure = {}

	moduleScope.querySelectorAll(`li.${parentElementClass}`).forEach(li => {
		let section = [];
		let sibling = li.nextElementSibling;
		while (sibling && (!sibling.classList.contains(parentElementClass))) {
			section.push(sibling)

			if (sibling.querySelector('button.onsite-navigation__item-link.-level__2')) {
				handleMoreButtonClick(sibling)
			}
			sibling = sibling.nextElementSibling;
		}
		listStructure[li.innerText] = section;

		function handleMoreButtonClick(moreButton) {
			moreButton.onclick = (e) => {
				e.preventDefault();
				const section = listStructure[li.innerText];
				section.forEach(element => element.classList.remove('hidden'));
				moreButton.remove();
			};
		}

	})
}
